// Slice 40 — mono "STAFF" chip with cyan halo. Reminds operators they're
// on the back-office, not the customer panel.

export function StaffBadge({ size = "md" }: { size?: "sm" | "md" }) {
  const s =
    size === "sm"
      ? { h: 18, fs: 9.5, px: 5, gap: 4, dot: 5 }
      : { h: 22, fs: 10, px: 7, gap: 5, dot: 6 };
  return (
    <span
      className="hq-mono"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: s.gap,
        height: s.h,
        padding: `0 ${s.px}px`,
        borderRadius: 4,
        border: "1px solid var(--hq-border-staff)",
        background: "rgba(34,211,238,.06)",
        color: "var(--hq-accent)",
        fontSize: s.fs,
        letterSpacing: ".1em",
        fontWeight: 600,
        textTransform: "uppercase",
      }}
    >
      <span
        style={{
          width: s.dot,
          height: s.dot,
          borderRadius: 99,
          background: "var(--hq-accent)",
          boxShadow: "0 0 0 3px rgba(34,211,238,.13)",
        }}
      />
      Staff
    </span>
  );
}
